import { AbstractApplicationPermissions } from '@netless/forge-room';
export let WhiteboardPermissionFlag = function (WhiteboardPermissionFlag) {
  /**
   * 没有任何权限, 只能同步的看他人绘制
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["none"] = 0] = "none";
  /**
   * 可以绘制元素
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["draw"] = 1] = "draw";
  /**
   * 可以修改自己创建的元素
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["editSelf"] = 2] = "editSelf";
  /**
   * 可以修改他人创建的元素
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["editOthers"] = 4] = "editOthers";
  /**
   * 可以删除自己创建的元素
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["deleteSelf"] = 8] = "deleteSelf";
  /**
   * 可以删除他人创建的元素
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["deleteOthers"] = 16] = "deleteOthers";
  /**
   * 可以修改主视角, 包括页面和画布状态, 添加页面, 删除页面
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["mainView"] = 32] = "mainView";
  /**
   * 可以修改他人的视角模式, 指定他人的页码
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["setOthersView"] = 64] = "setOthersView";
  /**
   * 拥有所有权限
   */
  WhiteboardPermissionFlag[WhiteboardPermissionFlag["all"] = WhiteboardPermissionFlag.draw | WhiteboardPermissionFlag.editSelf | WhiteboardPermissionFlag.editOthers | WhiteboardPermissionFlag.deleteSelf | WhiteboardPermissionFlag.deleteOthers | WhiteboardPermissionFlag.mainView | WhiteboardPermissionFlag.setOthersView] = "all";
  return WhiteboardPermissionFlag;
}({});
export class WhiteboardPermissions extends AbstractApplicationPermissions {
  /**
     * 解析权限列表组合
     * @param {number} value - 权限数字值
     * @return {WhiteboardPermissionFlag[]} - 权限列表
     */
  resolveFlags(value) {
    return [WhiteboardPermissionFlag.draw, WhiteboardPermissionFlag.editSelf, WhiteboardPermissionFlag.editOthers, WhiteboardPermissionFlag.deleteSelf, WhiteboardPermissionFlag.deleteOthers, WhiteboardPermissionFlag.mainView, WhiteboardPermissionFlag.setOthersView].filter(v => (v & value) !== 0);
  }
}